import { Button, CircularProgress, Dialog, DialogContent, Stack, Typography } from '@mui/material';

/** Confirmação antes de desistir do pagamento online — no checkout e na tela do pedido. */
export function DialogCancelarPagamento({
  aberto,
  titulo,
  descricao,
  cancelando = false,
  onVoltar,
  onConfirmar,
}: {
  aberto: boolean;
  titulo: string;
  descricao: string;
  /** O pedido está sendo cancelado: trava os dois botões. */
  cancelando?: boolean;
  onVoltar: () => void;
  onConfirmar: () => void;
}): JSX.Element {
  return (
    <Dialog open={aberto} onClose={cancelando ? undefined : onVoltar} maxWidth="xs" fullWidth>
      <DialogContent sx={{ p: 3 }}>
        <Stack spacing={2}>
          <Typography variant="h6">{titulo}</Typography>
          <Typography variant="body2" color="text.secondary">
            {descricao}
          </Typography>
          <Stack direction="row" spacing={1} justifyContent="flex-end">
            <Button onClick={onVoltar} disabled={cancelando}>
              Voltar
            </Button>
            <Button color="error" variant="contained" onClick={onConfirmar} disabled={cancelando}>
              {cancelando ? <CircularProgress size={20} color="inherit" /> : 'Sim, cancelar'}
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
